import React from "react";
import { pdf } from "@react-pdf/renderer";
import { PdpAuditPdf } from "../../components/PdpAudit/PdpAuditPdf";
import { PdpAuditResponse } from "../../components/PdpAudit/types";
import { PdpAuditReport } from "./useSalesData";

const toAuditResponse = (report: PdpAuditReport): PdpAuditResponse => ({
    audit: (report.report ?? {}) as PdpAuditResponse["audit"],
    meta: {
        url: report.url,
        finalUrl: report.url,
        title: "",
        metaDescription: "",
        jsonLdBlockCount: 0,
        geminiStatus: "success",
        geminiStatusCode: 200,
        geminiError: null,
    },
});

const slugify = (s?: string | null) =>
    (s || "product").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export async function downloadAuditReportPdf(report: PdpAuditReport) {
    const data = toAuditResponse(report);
    const blob = await pdf(<PdpAuditPdf data={data} />).toBlob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `PDP-Audit-${slugify(data.audit?.productName) || "product"}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
